/* eslint-disable no-shadow */
/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Add } from '@mui/icons-material';
// import { Button } from '@mui/material';
import Button from 'rsuite/Button';
import Accordion from 'rsuite/Accordion';
import Input from 'rsuite/Input';
import styles from './AllVendorsListPage.module.scss';
import { AddNewVendorModal } from '../../Components/Modals/AddNewVendorModal';
import AddressPanel from './AddressPanel';
import { formActions, modalActions } from '../../Actions';
import { AlertModal } from '../../Components/Modals';
import excel from '../../Images/excel.svg';
import allVendorServices from '@/Services/Form Services/allvendor.services';
import { getBase64FromFileBlob, handleResponseStreamDownload } from '@/Helpers';
import { useAuth } from '@/Components/Auth/Login/auth';
import { notificationServices } from '@/Services';
import authActions from '@/Actions/auth.actions';
import { BackdropLoader } from '@/Components/Loaders';
import { EyeIcon, Plus } from 'lucide-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { urls } from '@/Constants';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { vendorOrganisationServices } from '@/Services/VendorOrganisationServices/vendorOrganisation.services';

// ── HighlightText ─────────────────────────────────────────────────────────────
// Highlights all occurrences of `query` inside `text` with a yellow background.
function HighlightText({ text, query }) {
	if (!query || !query.trim() || !text) return <span>{text}</span>;
	const escaped = query.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const regex = new RegExp(`(${escaped})`, 'gi');
	const parts = String(text).split(regex);
	return (
		<span>
			{parts.map((part, i) =>
				regex.test(part) ? (
					<mark
						key={i}
						style={{
							backgroundColor: '#fff176',
							color: 'inherit',
							borderRadius: '2px',
							padding: '0 1px',
							fontWeight: 700,
						}}
					>
						{part}
					</mark>
				) : (
					<span key={i}>{part}</span>
				)
			)}
		</span>
	);
}

// ── Vendor Organisations Panel ────────────────────────────────────────────────
// ── Vendor Organisations Panel ────────────────────────────────────────────────
function VendorOrganisationsPanel({ vendorId, organisations, orgsLoading }) {
	const queryClient = useQueryClient();

	const { data: mappingsData, isLoading: mappingsLoading } = useQuery(
		['vendorMappings', vendorId],
		() => vendorOrganisationServices.listVendorMappings({ data: { vendorId } }),
		{
			enabled: !!vendorId,
			staleTime: 60000, // 1 minute cache for mappings
		}
	);

	const toggleMutation = useMutation(
		(payload) => vendorOrganisationServices.mapOrganisationVendors({ data: payload }),
		{
			onSuccess: () => {
				queryClient.invalidateQueries(['vendorMappings', vendorId]);
			},
			onError: (err) => {
				notificationServices.generateNotification({
					type: 'error',
					message: err?.message ?? 'Failed to update mapping',
				});
			},
		}
	);

	const allOrgs = organisations ?? [];
	const activeMappings = mappingsData?.data ?? [];
	const activeMappingMap = {};
	activeMappings.forEach((m) => {
		activeMappingMap[m.organisationId] = m;
	});

	const isLoading = orgsLoading || mappingsLoading;

	return (
		<div className='mt-1 w-full border-t border-gray-200 pt-4'>
			<p className='text-xs font-bold text-gray-500 uppercase tracking-widest mb-1'>Organisations</p>
			{isLoading ? (
				<p className='text-xs text-gray-400 italic'>Loading organisations...</p>
			) : allOrgs.length === 0 ? (
				<p className='text-xs text-gray-400'>No organisations created yet.</p>
			) : (
				<div className='flex gap-2 flex-wrap'>
					{allOrgs.map((org) => {
						const mapping = activeMappingMap[org.id];
						const isMapped = !!mapping;
						return (
							<div
								key={org.id}
								className='flex items-center justify-between px-3 py-2 bg-gray-50 rounded-md border border-gray-100 hover:bg-white transition-colors duration-200'
							>
								<div className='flex items-center gap-2'>
									<span className='text-sm text-gray-700 font-medium'>{org.name}</span>
									{isMapped ? (
										<span className='inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold bg-green-100 text-green-700'>● Active</span>
									) : (
										<span className='inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-400'>○ Not mapped</span>
									)}
								</div>
								<Button
									id={`vendor-org-toggle-${vendorId}-${org.id}`}
									appearance='ghost'
									size='xs'
									color={isMapped ? 'red' : 'green'}
									loading={toggleMutation.isLoading}
									onClick={() => {
										const currentActiveIds = activeMappings.map(m => m.organisationId);
										let newActiveIds;
										if (isMapped) {
											newActiveIds = currentActiveIds.filter(id => id !== org.id);
										} else {
											newActiveIds = [...currentActiveIds, org.id];
										}
										toggleMutation.mutate({
											vendorId,
											organisationIds: newActiveIds,
										});
									}}
								>
									{isMapped ? 'Remove' : 'Add'}
								</Button>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
}


const AllVendorListPage = (props) => {
	const {
		fetchVendors,
		data,
		buyersData,
		deleteVendor,
		toggleAlert,
		toggleAddVendorModal,
		type,
		navState,
		fetchUserList,
		userList,
	} = props;
	const { appConfig, userConfig } = useAuth();
	const [activeVendor, setActiveVendor] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [loading, setLoading] = useState(false);
	const uploadInputRef = useRef(null);
	const { level } = userConfig?.userDetails || {};
	const history = useHistory();
	const { userRolesDict } = userConfig;
	const isA2bCustomer = appConfig?.customerId === 68;
	const isInternal = Object?.values?.(userRolesDict ?? {}).some(role => role.toLowerCase().includes('internal'));
	const {
		masterCreation = true,
	} = appConfig?.configs ?? {};
	const masterDisallowedCreation = !((!isInternal && masterCreation) || (isInternal))



	const { data: orgsData, isLoading: orgsLoading } = useQuery(
		['organisations'],
		() => vendorOrganisationServices.listOrganisations({ data: {} }),
		{ staleTime: 300000 } // Keep organizations cache for 5 minutes
	);
	const allOrgs = orgsData?.data ?? [];

	const handleDelete = ({ vendor }) => {
		toggleAlert(true, {
			heading: 'Delete Vendor',
			height: '10rem',
			handleConfirm: () => {
				deleteVendor({
					entity: 'ALL_VENDORS',
					req: {
						params: {
							id: vendor?.id,
						},
					},
					method: 'DELETE',
				});
				toggleAlert(false);
			},
			colorReverse: true,
			cancelText: 'Cancel',
			confirmText: 'Delete',
			message: `Are you sure want to Delete Vendor - ${vendor?.name}?`,
		});
	};

	const fetchVendorsData = () => {
		fetchVendors({
			entity: type === 'VENDOR' ? 'ALL_VENDORS' : 'ALL_BUYERS',
			req: {
				params: {
					id: '',
				},
			},
			type,
			method: 'LIST',
		});
	};

	useEffect(() => {
		fetchVendorsData();
	}, [type]);
	const handleEditClick = (vendor) => {
		// eslint-disable-next-line no-console
		toggleAddVendorModal(true, {
			heading: type === 'VENDOR' ? 'Edit Vendor' : 'Edit Buyer',
			vendorData: vendor,
			isEdit: true,
			type,
			masterDisallowedCreation,
		});
	};

	const vendorHeader = (vendor, query) => {
		return (
			<div className={styles.vendor_header}>
				<div className={styles.vendor_details}>
					<div className={styles.name_company}>
						<p className={styles.vendor_name}><HighlightText text={vendor?.name} query={query} /></p>

						<p className={styles.vendor_name}>{' (ID: ' + vendor?.id + ')'}</p>
						{vendor?.companyName && (
							<p>
								Company:
								{vendor?.companyName}
							</p>
						)}
						{vendor?.isExpenseAllowed && (
							<p className={styles.expense_allowed}>
								Allowed For Expenses
							</p>
						)}
					</div>
					<div className={styles.details}>
						<div className={styles.field}>
							<label className=''>{type === 'VENDOR' ? 'Vendor Type:' : 'Buyer Type'}</label>
							<p>{vendor?.vendorType}</p>
						</div>
						<div className={styles.field}>
							<label className=''>{type === 'VENDOR' ? 'Vendor Sub Type:' : 'Buyer Sub Type:'}</label>
							<p>{vendor?.subType}</p>
						</div>
					</div>
					{type === 'BUYER' && vendor?.paymentTermCode && (
						<div className={styles.details}>
							<div className={styles.field}>
								<label className=''>Payment Term Code</label>
								<p>{vendor?.paymentTermCode}</p>
							</div>
						</div>
					)}
				</div>
				{type !== 'VENDOR' && level !== 1 && !isA2bCustomer && (
					<div className="flex items-center gap-3 mt-2 mb-2">
						<p className="text-gray-700 font-medium ml-2 text-[12px] text-nowrap">Map Items with Buyer’s System</p>
						{vendor?.productMappingExist ? (
							<Button
								appearance="subtle"
								className="!bg-[#e9eef3] !text-[#222] !font-semibold !rounded !px-3 !py-1 !text-[14px] !border !border-[#cfd8e3] !shadow-none flex items-center gap-1"
								style={{
									boxShadow: 'none',
									backgroundColor: '#e9eef3',
									color: '#222',
									fontWeight: 600,
									borderRadius: '6px',
									padding: '0.25rem 0.75rem',
									fontSize: '14px',
									border: '1px solid #cfd8e3',
								}}
								onClick={() => {
									history.push({
										pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
										search: `?id=${vendor?.id}&view=true`,
										state: {
											prevPath: history.location.pathname,
										},
									})
								}}
							>
								<EyeIcon className="mr-1" size={16} /> View Mapping
							</Button>
						) : (
							<Button
								appearance="primary"
								className="!bg-[#f7b500] !text-[#222] !font-semibold !rounded !px-3 !py-1 !text-[14px] !border !border-[#f7b500] !shadow-none flex items-center gap-1"
								style={{
									boxShadow: 'none',
									backgroundColor: '#f7b500',
									color: '#222',
									fontWeight: 600,
									borderRadius: '6px',
									padding: '0.25rem 0.75rem',
									fontSize: '14px',
									border: '1px solid #f7b500',
								}}
								onClick={() => {
									history.push({
										pathname: `${urls.EXTENSION}${urls.BUYER_PRODUCT_MAPPING}`,
										search: `?id=${vendor?.id}&add=true`,
										state: {
											prevPath: history.location.pathname,
										},
									})
								}}
							>
								<Plus className="mr-1" size={16} /> Add Mapping
							</Button>
						)}
					</div>
				)}
				{level !== 1 && (
					<div className={styles.btns_container}>
						<Button
							onClick={() => {
								handleEditClick(vendor);
							}}
							appearance='ghost'
						>
							Edit
						</Button>
						<Button
							onClick={() => {
								handleDelete({
									vendor,
								});
							}}
							appearance='ghost'
							color='red'
						>
							Delete
						</Button>
					</div>
				)}
			</div>
		);
	};

	const handleExport = async (list) => {
		try {
			setLoading(true);
			let response;
			const name = type === 'VENDOR' ? 'VENDOR' : 'BUYER';
			if (type === 'VENDOR') {
				response = await allVendorServices.exportVendors({
					req: {
						data: list,
					},
				});
			} else {
				response = await allVendorServices.exportBuyers({
					req: {
						data: list,
					},
				});
			}
			if (response.status === 200) {
				handleResponseStreamDownload(
					response,
					`${name}_${appConfig?.companyName
						?.split(' ')
						?.join('_')
						?.toUpperCase()}.csv`
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setLoading(false);
		}
	};

	const handleUpload = async (event) => {
		const file = event?.target?.files?.[0];
		if (!file) return;
		try {
			setLoading(true);
			const base64File = await new Promise((resolve) => {
				getBase64FromFileBlob(file, resolve);
			});
			const response = await allVendorServices.uploadVendors({
				vendorData: base64File,
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message || `${type === 'VENDOR' ? 'Vendors' : 'Buyers'} uploaded successfully`,
				});
				fetchVendorsData();
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'Unable to upload file',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Unable to upload file',
			});
		} finally {
			if (event?.target) {
				event.target.value = '';
			}
			setLoading(false);
		}
	};

	const downloadTemplate = () => {
		const headers = [
			'Entity Name',
			'Legal Name',
			'Entity Code',
			'Entity Type',
			'Location Name',
			'GST',
			'Entity Location Code',
			'Location Address Line 1',
			'Location Address Line 2',
			'Location City',
			'Location State',
			'Location Pincode',
			'Shipping Address Line 1',
			'Shipping Address Line 2',
			'Shipping City',
			'Shipping State',
			'Shipping Pincode',
		];
		const sampleRow = [
			type === 'VENDOR' ? 'Sample Vendor' : 'Sample Buyer',
			type === 'VENDOR' ? 'Sample Vendor Pvt Ltd' : 'Sample Buyer Pvt Ltd',
			type === 'VENDOR' ? 'VENDOR_001' : 'BUYER_001',
			type === 'VENDOR' ? 'Original Manufacturer' : 'Buyer',
			'Main Location',
			'27ABCDE1234F1Z5',
			type === 'VENDOR' ? 'VLOC_001' : 'BLOC_001',
			'Address line 1',
			'Address line 2',
			'Mumbai',
			'Maharashtra',
			'400001',
			'Shipping address line 1',
			'Shipping address line 2',
			'Mumbai',
			'Maharashtra',
			'400001',
		];
		const csvContent = [headers, sampleRow].map((row) => row.join(',')).join('\n');
		const fileBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const downloadLink = document.createElement('a');
		downloadLink.href = window.URL.createObjectURL(fileBlob);
		downloadLink.download = `${type === 'VENDOR' ? 'vendor' : 'buyer'}_upload_template.csv`;
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
	};

	return (
		<div className={styles.root}>
			<AddNewVendorModal fetchVendorsData={fetchVendorsData} pageType={type} />
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />
			<div className={styles.header}>
				<div className={styles.header_search}>
					<p className={styles['header-title']}>
						{type === 'VENDOR' ? 'All Vendors' : 'All Buyers'}
					</p>
					<div className={styles.filters}>
						<Input
							value={searchQuery}
							onChange={(value) => {
								setSearchQuery(value);
							}}
							style={{
								width: 300,
								borderRadius: 25,
								border: '1px solid #000',
							}}
							placeholder={type === 'VENDOR' ? 'Search by name or location code' : 'Search by name or location code'}
						/>
					</div>
				</div>
				{level !== 1 && (
					<div className='relative'>
						<button
							onClick={() => {
								toggleAddVendorModal(true, {
									type,
								});
							}}
							type='button'
							className={`${styles['add-btn']} ${masterDisallowedCreation ? '!opacity-50 !bg-gray-300' : ''}`}
							disabled={masterDisallowedCreation}
						>
							<Add />
							{type === 'VENDOR' ? 'Add Vendor' : 'Add Buyer'}
						</button>
						{masterDisallowedCreation && (
							<div className='absolute z-10 -bottom-4 w-full flex items-center justify-center '>
								<p className='text-red-500 text-[10px] text-nowrap whitespace-nowrap'>Direct creation not allowed</p>
							</div>
						)}
					</div>
				)}
			</div>
			<div className='flex justify-end w-full p-2'>
				<input
					ref={uploadInputRef}
					type='file'
					accept='.csv,text/csv'
					style={{ display: 'none' }}
					onChange={handleUpload}
				/>
				<div
					onClick={downloadTemplate}
					className={styles.downloadData}
					style={{ marginRight: '10px' }}
				>
					<img src={excel} alt='excel' />
					<span className='text-xs'>DOWNLOAD TEMPLATE</span>
				</div>
				<div
					onClick={() => {
						uploadInputRef.current?.click();
					}}
					className={styles.downloadData}
					style={{ marginRight: '10px' }}
				>
					<img src={excel} alt='excel' />
					<span className='text-xs'>UPLOAD</span>
				</div>
				<div
					onClick={() => {
						// eslint-disable-next-line no-undef
						handleExport(type === 'VENDOR' ? data : buyersData);
					}}
					className={styles.downloadData}
				>
					<img src={excel} alt='excel' />
					<span className='text-xs'>EXPORT</span>
				</div>
			</div>
			<Accordion
				activeKey={activeVendor}
				bordered
				onSelect={setActiveVendor}
			>
				{(type === 'VENDOR' ? data : buyersData)
					.filter((vendor) => {
						const q = searchQuery?.trim()?.toLowerCase();
						if (!q) return true;
						// Match vendor/buyer name
						if (vendor?.name?.toLowerCase().includes(q)) return true;
						// Match any location name or location code
						return vendor?.vendor_locations?.some((loc) =>
							loc?.name?.toLowerCase().includes(q) ||
							String(loc?.clientLocationId ?? '').toLowerCase().includes(q)
						);
					})
					.map((vendor) => {
						return (
							<Accordion.Panel
								header={vendorHeader(vendor, searchQuery)}
								eventKey={vendor?.id}
							>
								<div className={styles.accordion_body}>
									{/* Vendor Organisations Mapping Panel - Moved up and conditional */}
									{/* {activeVendor === vendor?.id && allOrgs.length > 0 && (
										<VendorOrganisationsPanel 
											vendorId={vendor?.id} 
											organisations={allOrgs}
											orgsLoading={orgsLoading}
										/>
									)} */}
									<div className={styles.locations}>
										{vendor?.vendor_locations?.map(
											(ele) => {
												return (
													<div
														className={
															styles.location
														}
													>
														<div
															className={
																styles.location_header
															}
														>
															<p
																className={
																	styles.location_name
																}
															>
																<HighlightText text={ele?.name} query={searchQuery} />
																{ele?.clientLocationId && (
																	<span style={{ marginLeft: '6px', fontSize: '0.8em', color: '#555', fontWeight: 400 }}>
																		(Code:&nbsp;
																		<HighlightText text={String(ele.clientLocationId)} query={searchQuery} />
																		)
																	</span>
																)}
															</p>
															<p
																className={
																	styles.location_name
																}
															>
																GSTIN:
																{' '}
																{ele?.gstin}
															</p>
														</div>
														<div
															className={
																styles.location_detatils
															}
														>
															<div
																className={
																	styles.field
																}
															>
																<label>
																	Location
																	Email:
																</label>
																<p>
																	{
																		ele?.vendorEmail
																	}
																</p>
															</div>
															<div
																className={
																	styles.field
																}
															>
																<label>
																	Location
																	Phone:
																</label>
																<p>
																	{
																		ele?.vendorPhone
																	}
																</p>
															</div>
														</div>
														<AddressPanel
															addressDetails={{
																addressType:
																	'Billing Address',
																address1:
																	ele?.billingAddress1,
																address2:
																	ele?.billingAddress2,
																city: ele?.billingAddressCity,
																state: ele?.billingAddressState,
																pincode:
																	ele?.billingAddressPinCode,
															}}
														/>
														<AddressPanel
															addressDetails={{
																addressType:
																	'Pickup Address',
																address1:
																	ele?.shippingAddress1,
																address2:
																	ele?.shippingAddress2,
																city: ele?.shippingAddressCity,
																state: ele?.shippingAddressState,
																pincode:
																	ele?.shippingAddressPinCode,
															}}
														/>
													</div>
												);
											}
										)}
									</div>
								</div>
							</Accordion.Panel>
						);
					})}
			</Accordion>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_VENDORS.data.LIST;
	const buyersData = state.form.ALL_BUYERS.data.LIST;
	const { navState, userPermissions } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		buyersData,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchVendors: formActions.gateway,
	deleteVendor: formActions.gateway,
	toggleAddVendorModal: modalActions.toggleAddVendorModal,
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllVendorListPage);
